module.exports = __webpack_public_path__ + "static/media/alarm-response.ceb8c94c.jpg";